/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LaunchAction/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromHelpers from './helpers.js'
import React from 'react'
import TysiaButtonWithText from 'DesignSystem/TysiaButtonWithText/index'



/** @type {import('Simple/types.js').View} */
export default function LaunchAction({
  children,
  url,
  viewPath = "/App/Account/Topbar/Options/Content/Apps/Content/App/AppAction/ActionQr/Content/LaunchAction"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let onClick = fromHelpers.useOnClick({
  children,
  url,
  viewPath
  
})
  return (<React.Fragment
>
<TysiaButtonWithText
  viewPath={`${viewPath}/TysiaButtonWithText`}
 type="primary"
 onClick={onClick}
 text="Launch"
 marginLeft={dtSpaceXs}
/>
{children}
</React.Fragment>)
}